export default function NotFound() {
  return (
    <div>
      <h1>404 NOT FOUND:(</h1>
    </div>
  );
}
